import React, { Fragment, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import { H5, H6 } from '../../AbstractElements';
import FaqRightsidebae from './FaqRightside';
import FaqContext from '../../Context/Faq';
import { QuickQuestions } from '../../Constant';
import AccordionCard from './AccordionCard';

const Questionss = () => {
  const { faq } = useContext(FaqContext);

  return (
    <Fragment>
      <Col lg='12'>
        <div className='header-faq'>
          <H5 className='mb-0'>{QuickQuestions}</H5>
        </div>
        <Row className='default-according style-1 faq-accordion' id='accordionoc'>
          <Col xl='8 xl-60' lg='6' md='7' className='box-col-60'>
            {faq &&
              faq.map((item, i) => {
                return (
                  <Fragment key={i}>
                    {item.subTitle && (
                      <div className='faq-title'>
                        <H6>{item.subTitle}</H6>
                      </div>
                    )}
                    {faq[i].titless.map((item, id) => {
                      return <AccordionCard key={id} item={item} />;
                    })}
                  </Fragment>
                );
              })}
          </Col>
          <FaqRightsidebae />
        </Row>
      </Col>
    </Fragment>
  );
};
export default Questionss;
